import { render, staticRenderFns } from "./rating-scale.vue?vue&type=template&id=64a7a902&scoped=true"
import script from "./rating-scale.vue?vue&type=script&lang=js"
export * from "./rating-scale.vue?vue&type=script&lang=js"
import style0 from "./rating-scale.vue?vue&type=style&index=0&id=64a7a902&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a7a902",
  null
  
)

export default component.exports